import React from 'react';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';

import { useStore } from 'core/store';
import { getPolicyLines } from './policy-lines';
import { PolicyCard } from './policy-card';
import useStyles from './policy-cards.styles';

/**
 * Modify Quote's policy cards (#36357, Policy cards lane #36398): one card per policy in the selected
 * option, stacked for a bundle. Replaces today's price details card for Staff Quote Revisit.
 *
 * Prices and schedules are the server's, for the offer as last saved, so billing settings come from the
 * store's quote.global rather than the form's unsaved values.
 */
const PolicyCards = observer(() => {
  const classes = useStyles();
  const { offer: store } = useStore();
  const { values } = useFormikContext();

  const policies = getPolicyLines({
    selectedOption: values.selectedOption,
    options: store.offer?.options,
    global: store.offer?.quote?.global,
    state: store.state
  });
  if (!policies.length) {
    return null;
  }

  return (
    <div id="offer_policy_cards" className={classes.policyCards}>
      {policies.map((policy) => (
        <PolicyCard key={policy.key} policy={policy} />
      ))}
    </div>
  );
});

export default PolicyCards;
